<template>
	<div class="ratholOrChair">
		<div class="van-overlay"></div>
		<div class="van-popup van-popup--center relative" style="z-index: 2002;">
			<img v-if="showCloseBtn" src="../assets/images/close.png" class="close absolute" alt srcset @click="closePopDialog" />

			<div class="wrapper PingFang-Medium">
				<!-- 标题 -->
				<div v-if="title != ''" :class="['title', 'color-333', 'ft-40', 'flex', 'flex-ac', 'flex-jc', 'ft-bold','pd-bt49']">{{title}}</div>

				<div class="list-content" v-if="type == 'buyPaper' || type == 'buyDeskcode'">
					<div class="cont-title-box">
						<div v-for="(item, i) in list" class="cont-title-item" :class="{'cont-title-item-ac': i == idx}" @click="idx = i;">{{ item.title }}</div>
					</div>
					<div class="content">
						<div class="msglist-cont">
							<div v-for="(item, index) in thisPaper.msgs" :key="index">{{ item }}</div>
							<div class="sms-skm" v-if="typeof thisPaper.image == 'string'">
								<img :src="thisPaper.image" />
							</div>
							<div class="sms-skm dialog-img-line-box" v-if="typeof thisPaper.image == 'object'">
								<img class="dialog-img-line-item" v-for="item in thisPaper.image" :src="item" />
							</div>
						</div>
					</div>
				</div>
				<div class="content" v-else>
					<template v-if="type == 'totalDiscount' || type == 'totalOther'">
						<div style="width: 75%;">
							<div v-for="(item, index) in data.dis" :key="index" class="disdata-item">
								<span>{{ item.name }}</span>
								<span>￥{{ item.value }}</span>
							</div>
						</div>
					</template>
					<template v-if="type == 'scandesk' || type == 'carefulMatter' || type == 'smsRecharge' || type == 'buyTips'">
						<div class="msglist-cont">
							<div v-for="(item, index) in data.msgs" :key="index">{{ item }}
								<span v-if="type == 'buyTips' && index == data.msgs.length - 1" class="text-underline color-FE724F" @click.stop="toContact">联系我们</span>
							</div>
							<div v-if="type == 'smsRecharge' || type == 'buyTips'" class="sms-skm">
								<img :src="data.image" />
							</div>
						</div>
					</template>
					<div
						class="deskcontent"
						:class="{
							'alltext-lh': type == 'beMember'|| type == 'memCharge' || type == 'memRecord' || type == 'memReturn',
						}"
						v-else
					>{{ message }}</div>
				</div>
			</div>
				<div v-if="showCancelBtn || showConfirmBtn" style="height: 1.5rem;"></div>
			<!-- 确认/取消 -->
			<div class="btns flex flex-jc">
				<button class="cancel" v-if="showCancelBtn" @click="closePopDialog">{{ cancelText }}</button>
				<button class="confirm " v-if="showConfirmBtn" @click="confirmPopDialog">{{ confirmText }}</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: '提示'
		},
		message: {
			type: String,
			default: ''
		},
		showCancelBtn: {
			type: Boolean,
			default: true
		},
		cancelText: {
			type: String,
			default: '取消'
		},
		showConfirmBtn: {
			type: Boolean,
			default: true
		},
		confirmText: {
			type: String,
			default: '确认'
		},
		type: {
			type: String,
			default: ''
		},
		data: {
			type: Object,
			default: {}
		},
		list: {
			type: Array,
			default() {
				return []
			},
		},
		showCloseBtn: {
			type: Boolean,
			default() {
				return true
			}
		}
	},
	data() {
		return {
			idx: 0,
		};
	},
	async mounted() {
		
	},
	computed: {
		thisPaper() {
			// console.log(this.list[this.idx]);
			return this.list[this.idx];
		}
	},
	methods: {
		toContact() {
			this.$router.push({
				name: 'aboutDZB',
				query: {
					type: 2,
				}
			})
			this.closePopDialog();
		},
		closePopDialog() {
			this.$emit("closePopDialog", { type: this.type, data: this.data });
		},
		confirmPopDialog() {
			this.$emit('confirmPopDialog', { type: this.type, data: this.data })
		}
	}
};
</script>

<style lang="less" scoped>
.disdata-item {
	padding: 0.4rem 0.1rem;
	border-bottom: 0.02rem rgba(0, 0, 0, 0.06) solid;
	display: flex;
	justify-content: space-between;
	font-size: 0.4rem;
}
// .disdata-item:last-child {
// 	border-bottom: none;
// }
* {
	box-sizing: border-box;
}
.pd-bt49 {
	padding-bottom: 0.49rem;
}
.ratholOrChair {
	.van-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.7);
		z-index: 999;
	}
	.van-popup {
		width: 12rem;
		max-height: 12rem;
		height: fit-content;
		border-radius: 0.13rem;
	}
	.close {
		width: 0.38rem;
		height: 0.38rem;
		right: 0.3rem;
		top: 0.3rem;
		z-index: 10;
	}
	.wrapper {
		padding: 0rem 0.71rem;
		position: relative;
	
		.title {
			padding-top: 0.51rem;
			border-bottom: 0.02rem solid rgba(204, 204, 204, 1);
		}
	}
	.btns {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 1.25rem;
		.confirm,
		.cancel {
			color: #fff;
			min-width: 2.87rem;
			height: 0.9rem;
			border-radius: 0.13rem;
			font-size: 0.36rem;
			padding: 0 0.3rem;
		}
		.cancel {
			background: #EAEAEA;
			color: #666666;
			margin-right: 1rem;
		}
		.confirm {
			background: #FE724F;
		}
	}
}
.content {
	margin: 0.5rem 0.5rem 0.6rem;
	position: relative;
	min-height: 18vh;
	height: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	.deskcontent {
		display: flex;
		align-items: flex-start;
		font-size: 0.4rem;
		line-height: 1.6;
	}

	.alltext-lh {
		line-height: 1.8;
	}

	.msglist-cont {
		font-size: 0.4rem;
		line-height: 1.6;
		width: 100%;

		.sms-skm {
			width: 5.5rem;
			height: 6.6rem;
			margin: 0 auto;
			img {
				width: 100%;
				height: 100%;
			}
		}

		.dialog-img-line-box {
			display: flex;
			width: 100%;
			height: 5rem;
			align-items: center;
			justify-content: space-between;

			.dialog-img-line-item {
				width: 4.5rem;
				height: 4.5rem;
			}
			.dialog-img-line-item:nth-child(2) {
				margin-right: 0;
			}
		}
	}

}

.list-content {
	.content {
		margin-top: 0.35rem;
		margin-bottom: 0.35rem;
	}
	.cont-title-box {
		display: flex;
		justify-content: center;
		.cont-title-item {
			text-align: center;
			line-height: 1rem;
			width: 31%;
			height: 1rem;
			border: 0.02rem solid #DEDEDE;
			font-size: 0.39rem;
			color: #666666;
			margin-top: 0.35rem;
		}
	
		.cont-title-item:nth-child(1) {
			border-right: none;
			border-radius: 0.13rem 0 0 0.13rem;
		}
		.cont-title-item:nth-child(3) {
			border-left: none;
			border-radius: 0 0.13rem 0.13rem 0;
		}
	
		.cont-title-item-ac {
			background: #FE724F;
			border-color: #FE724F;
			color: #fff;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/popupOfDialog.vue